import { render, staticRenderFns } from "./partnerApiIntegration.vue?vue&type=template&id=3581f1e9&"
import script from "./partnerApiIntegration.vue?vue&type=script&lang=js&"
export * from "./partnerApiIntegration.vue?vue&type=script&lang=js&"
import style0 from "./partnerApiIntegration.vue?vue&type=style&index=0&id=3581f1e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports